import { getApiKey } from "../utils/apiKey";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Link, useHistory, useLocation } from "routerCompat";
import { apiCall_domain } from "./api";
import PulseLoader from "react-spinners/PulseLoader";
import AdvanceSearchModal from "./global/AdvanceSearchModal";

const words = ["برند", "سایز", "خودرو", "دسته بندی"];

const Header = (props) => {
  const history = useHistory();
  const location = useLocation();
  const headerRef = useRef(null);
  const searchTimeout = useRef(null);

  const [searchValue, setSearchValue] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [noServiceCount, setNoServiceCount] = useState(0);
  const [serviceCount, setServiceCount] = useState(0);
  const [showSearch, setShowSearch] = useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [index, setIndex] = useState(0);
  const [isEditing, setIsEditing] = useState(false);

  const {
    showSearchBar,
    isMainPage,
    isDarkTheme,
    showBasket,
    backHandler,
    likeIcon,
    title,
    filledIcon,
    handleLike,
    shoppingCardCount,
    backUrl,
    top_tag,
  } = props;

  const isMainPageRoute = location.pathname.includes("mainPage");

  /* ---------------- Rotating Words ---------------- */

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((i) => (i + 1) % words.length);
    }, 5000);
    return () => clearInterval(id);
  }, []);

  /* ---------------- Cart Count ---------------- */

  useEffect(() => {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };

    axios
      .get(`${apiCall_domain}/customer/shopping-cart`, { headers })
      .then((res) => {
        res.data.data.types.forEach((item) => {
          item.type === 1
            ? setNoServiceCount(item.items.length)
            : setServiceCount(item.items.length);
        });
      })
      .catch((err) => {
        console.error("Failed to fetch cart:", err);
      });
  }, []);

  /* ---------------- Reset on Route Change ---------------- */

  useEffect(() => {
    document.body.style.overflow = "auto";
    setShowSearch(false);
    setSearchValue("");
    setSearchResult([]);
    setIsEditing(false);
  }, [location.pathname]);

  /* ---------------- Search ---------------- */

  const search = ({ target }) => {
    const value = target.value;
    setSearchValue(value);

    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    if (!value) {
      setShowSearch(false);
      setSearchResult([]);
      setIsSearchLoading(false);
      document.body.style.overflow = "auto";
      return;
    }

    setShowSearch(true);
    setIsSearchLoading(true);

    searchTimeout.current = setTimeout(() => {
      axios
        .get(`${apiCall_domain}/customer/search?word=${value}`, {
          headers: {
            Authorization: getApiKey(),
            "content-type": "application/json",
          },
        })
        .then((res) => {
          document.body.style.overflow = "hidden";
          setSearchResult(res.data.data);
        })
        .catch((err) => {
          console.error("Search failed:", err);
        })
        .finally(() => {
          setIsSearchLoading(false);
        });
    }, 500);
  };

  const goBackUrl = () => {
    backUrl ? history.push(backUrl) : history.goBack();
  };

  const closeSearch = () => {
    setTimeout(() => {
      setIsEditing(false);
    }, 150); // slight delay so Link clicks register before blur
  };

  /* ---------------- Render ---------------- */

  return (
    <>
      {top_tag && (
        <a href={`/tags/${top_tag.slug}`}>
          <img
            src={top_tag.pic}
            alt={top_tag.slug}
            style={{ width: "100%", height: "60px", objectFit: "cover" }}
          />
        </a>
      )}

      <div
        className={`header ${
          showSearchBar && !isMainPageRoute ? "withSearchIcon" : ""
        } ${isDarkTheme ? "darkTheme" : "lightTheme"}`}
      >
        <div className="headerMainContainer">
          <div className="backIcon">
            {isMainPage ? (
              <Link to="/showmore" className="showMoreIcon">
                <div />
                <div />
                <div />
              </Link>
            ) : (
              <i
                className="icon-chevron-right"
                onClick={backHandler || goBackUrl}
              />
            )}
          </div>

          {isMainPage && (
            <div className="kacharMainIcon">
              <img src="./public/assets/logo.svg" alt="kacharLogo" />
            </div>
          )}

          {title && (
            <div className="title">
              <span>{title}</span>
            </div>
          )}

          <div className="iconSection">
            {showBasket && (
              <Link to="/shoppingCart">
                <div className="basketIcon">
                  <i className="icon-cart" />
                  <span className="basketItemCount">
                    {shoppingCardCount ?? serviceCount + noServiceCount}
                  </span>
                </div>
              </Link>
            )}

            {likeIcon && (
              <div className="likeIcon">
                <i
                  onClick={handleLike}
                  className={
                    filledIcon
                      ? "icon-heart-filled-product"
                      : "icon-empty-heart"
                  }
                />
              </div>
            )}
          </div>
        </div>

        {/* ---------- Main Page Search Bar ---------- */}
        {showSearchBar && isMainPageRoute ? (
          <div className="searchBar">
            <div
              ref={headerRef}
              className="HeaderSearch"
              onClick={() => setIsEditing(true)}
            >
              {isEditing ? (
                <input
                  value={searchValue}
                  onChange={search}
                  autoFocus
                  onFocus={() => setShowSearch(true)}
                  placeholder="جستجو کنید..."
                  onBlur={closeSearch}
                />
              ) : (
                <>
                  <span>جستجو محصولات براساس</span>
                  <strong>{words[index]}</strong>
                </>
              )}
            </div>

            {showSearchModal && (
              <AdvanceSearchModal
                open={showSearchModal}
                handleClose={() => setShowSearchModal(false)}
              />
            )}

            {showSearch && (
              <div className="searchResult">
                {isSearchLoading ? (
                  <div className="searchLoading">
                    <PulseLoader size={14} color="#831f82" />
                  </div>
                ) : searchResult.length > 0 ? (
                  <ul>
                    {searchResult.map((item) => (
                      <li key={item.id}>
                        <Link to={`/product/${item.id}`}>{item.name}</Link>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className="searchPlaceholder">
                    <li>
                      <span className="hint">عبارت مورد نظر را جستجو کنید</span>
                      <div className="advanceSearch">
                        <button
                          onClick={() => {
                            setShowSearchModal(true);
                            setIsEditing(false);
                          }}
                        >
                          برای جستجوی پیشرفته کلیک کنید
                        </button>
                      </div>
                    </li>
                  </div>
                )}
              </div>
            )}
          </div>
        ) : showSearchBar && !isMainPageRoute ? (
          /* ---------- Non-Main Page Search Bar ---------- */
          <div className="searchBar">
            <img
              onClick={() => {
                setIsEditing(true);
                setShowSearch(true);
              }}
              src="/public/assets/icons/search-normal.svg"
              alt="searchIcon"
            />

            {showSearchModal && (
              <AdvanceSearchModal
                open={showSearchModal}
                handleClose={() => setShowSearchModal(false)}
              />
            )}

            {showSearch && (
              <div className="searchPlaceholder">
                <div className="search">
                  <img
                    src="/public/assets/icons/search-normal.svg"
                    alt="searchIcon"
                  />
                  <input
                    placeholder="جستجو در کاچار ..."
                    value={searchValue}
                    onChange={search}
                    autoFocus
                  />
                </div>

                <div className="searchResult">
                  {isSearchLoading ? (
                    <div className="searchLoading">
                      <PulseLoader size={14} color="#831f82" />
                    </div>
                  ) : searchResult.length > 0 ? (
                    <ul>
                      {searchResult.map((result) => (
                        <li key={result.id}>
                          <Link to={`/product/${result.id}`}>
                            <span className="searchCircle" />
                            <span className="searchSlug">{result.name}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="searchLoading">
                      <PulseLoader size={14} color="#831f82" />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        ) : null}
      </div>
    </>
  );
};

export default Header;
